import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioConsultaPlanoAnualContratacoes: [],
    removeStatusConsultaPlanoAnualContratacoes: [],
    setMostraAplicarFiltroConsultaPlanoAnualContratacoes: [],
    limpaFiltroConsultaPlanoAnualContratacoes: [],
    aplicarFiltroConsultaPlanoAnualContratacoes: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_CONSULTA_PLANO_ANUAL_CONTRATACOES]: removeExercicio,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_PLANO_ANUAL_CONTRATACOES]: setMostraAplicarFiltro,
    [Types.REMOVE_STATUS_CONSULTA_PLANO_ANUAL_CONTRATACOES]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_PLANO_ANUAL_CONTRATACOES]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_PLANO_ANUAL_CONTRATACOES]: aplicarFiltro,
})
